import type { FaireProductEntity } from "../../entity_types/product";

export const p_qt4k3gc3qv: FaireProductEntity = {
  token: "p_qt4k3gc3qv",
  type: "product",
  name: "Cast Iron Seasoning",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0d0c3202b7075acb37e488e9ecbd4dcb4666f21c8acdadc9855278acf9338c96.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.32,
  description:
    "Cast iron cooking just got simpler! The key to cooking with cast iron is to create a beautifully seasoned pan for optimal non-stick characteristics. This blend of 100% organic oils & beeswax help to do just that.\n\nTo Use: Wash & thoroughly dry your cookware, apply a dime sized amount of cast iron seasoning with a dish towel or paper towel and coat the pan evenly, warm the cookware in the oven or on the stovetop briefly and wipe off any excess before storing.\n\nIngredients: Flax Seed Oil*, Coconut Oil*, Pure Beeswax. *Organic",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:21.905Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
